// extracted by mini-css-extract-plugin
export default {"Title":"styles_Title__2pRfL","closeIcon":"styles_closeIcon__h+mnT"};